import { controls } from "../../../controls";

const rp738 = {
  label: "Overdue Register",
  starting: true,
  url: "rp738",
  pageLabel: "Overdue Register",
  pageType: "history",
  form: [],
  filter: [
    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.displayText({ tab: "filter", label: "Product Type", width: "col-sm-2" }),
    ...controls.ProductType({
      tab: "filter",
    }),
    ...controls.showData({ tab: "filter", data: "product_type_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.displayText({ tab: "filter", label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ tab: "filter", }),
    ...controls.showData({ tab: "filter", data: "product_code_display", name: "product_code_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.magicDateLabel({ tab: "filter", star: true, label: "As On Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", isRequired: true, dateType: "ontype", name: "as_on_date", width: "col-sm-2", default: "sessiondate" }),

    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),

    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Account No From-To",
      name: "",
      description: ""
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "account_number_from",
      description: ""
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "account_number_to",
      description: ""
    },

    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Top No of A/Cs",
      name: "",
      description: ""
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Top No Of Accounts",
      name: "top_no_of_accounts",
      description: "Enter Top No Of Accounts"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Sanction Amount From-To",
      name: "",
      description: ""
    },
    {
      inputType: "numberonly",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "saction_amount_from",
      description: ""
    },
    {
      inputType: "numberonly",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "saction_amount_to",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Overdue Type",
      name: "",
      description: ""
    },
    {
      inputType: "select",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "Installment Overdue",
          value: "Installment Overdue"
        },
        {
          label: "Expiry Overdue",
          value: "Expiry Overdue"
        },
        {
          label: "All",
          value: "All"
        },

      ],
      placeHolder: "",
      label: "",
      name: "over_due_type",
      description: ""
    },
    {
      inputType: "checkbox",
      tab: "filter",
      widths: {
        parent: "col-sm-8",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Send SMS",
      name: "isSenSMS",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "OD Installments From-To",
      name: "",
      description: ""
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "od_installment_from",
      description: ""
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "od_installment_to",
      description: ""
    },
    {
      inputType: "checkbox",
      tab: "filter",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "With Zero Overdue",
      name: "isWithZeroOverdue",
      description: ""
    },
    ...controls.magicDateLabel({ tab: "filter", label: "Expirt Date From-To", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "expiry_from_date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "expiry_to_date", width: "col-sm-2" }),

    {
      inputType: "checkbox",
      tab: "filter",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Calculate Interest",
      name: "isCalculateInteres",
      description: ""
    },
    ...controls.magicDateLabel({ tab: "filter", label: "Open Date From-To", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "open_from_date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "open_to_date", width: "col-sm-2" }),


  ],
  history: {
    perPage: 10,
    reportHeader: "Deposit Accounts",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [

      {
        Header: "A/C No",
        accessor: "account_number",
        width: 150
      },

      {
        Header: "CIN",
        accessor: "cin",
      },
      {
        Header: "Description",
        accessor: "description",
      },
      {
        Header: "NPA Status",
        accessor: "npastatus",
      },
      {
        Header: "Open Date",
        accessor: "open_date",
      },
      {
        Header: "Expiry Date",
        accessor: "expirydate",
      },
      {
        Header: "Sanction Amount",
        accessor: "sanction_amount",
        type: "currency",

      },

    ]
  }
}
export default rp738